import {compose} from 'redux';
import withCitiesAndStreets from '../../../../common/components/hoc-helpers/withCitiesAndStreets';
import TaxAuthorityPage from './TaxAuthorityPage';

export default compose(
  withCitiesAndStreets
)(TaxAuthorityPage);